"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestLink = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const image_media_1 = require("@festival/component/image-media");
const reactstrap_1 = require("reactstrap");
class GuestLink extends React.Component {
    render() {
        const { uuid, routeManager, guestStore } = this.props;
        if (!routeManager || !guestStore) {
            return null;
        }
        const guest = guestStore.get(uuid);
        if (!guest) {
            return null;
        }
        return this.renderContent(guest, routeManager);
    }
    renderContent(guest, routeManager) {
        return (React.createElement(reactstrap_1.Card, null,
            React.createElement(react_router_dom_1.Link, { to: routeManager.generate('guest-show', { params: { slug: guest.active.slug } }) },
                React.createElement(image_media_1.default, { media: guest.active.media, name: "sticker", version: "large", className: "card-img-top", alt: guest.active.altSticker })),
            React.createElement(reactstrap_1.CardBody, null,
                React.createElement(react_router_dom_1.Link, { to: routeManager.generate('guest-show', { params: { slug: guest.active.slug } }) },
                    React.createElement(reactstrap_1.CardTitle, { tag: "h5" }, guest.active.name)))));
    }
}
exports.GuestLink = GuestLink;
exports.default = mobx_react_1.inject('routeManager', 'guestStore')(mobx_react_1.observer(GuestLink));
